import React from 'react';
import './SideMenu/css/CardView.css'; // You can create a CSS file for styling
import SideMenuData from './SideMenu/SideMenuData';
import { NavLink } from 'react-router-dom';

const CardView = () => {
  const filteredMenuData = SideMenuData.filter((item) => item.label !== "Dashboard");
  return (
    <div className="card-menu-container">
      {filteredMenuData.map((item, index) => (
        <React.Fragment key={index}>
          {item.submenuItems.length > 0 ? (
            item.submenuItems.map((submenuItem) => (
              <React.Fragment key={submenuItem.id}>
                {submenuItem.submenuItems1.length > 0 && (
                  submenuItem.submenuItems1.map((subItem) => (
                    <NavLink to={subItem.link} key={subItem.id}>
                      <div className="card">
                        <div className='card-top'>
                          <div className='card-icon'>{item.icon}</div>
                          <div className="card-label">{item.label}</div>
                        </div>
                        <div className='card-bottom'>
                          <div className='card-submenu'>{subItem.label}</div>
                        </div>
                      </div>
                    </NavLink>
                  ))
                )}
                {!submenuItem.submenuItems1.length > 0 && (
                  <NavLink to={submenuItem.link} key={submenuItem.id}>
                    <div className="card">
                      <div className='card-top'>
                        <div className='card-icon'>{item.icon}</div>
                        <div className="card-label">{item.label}</div>
                      </div>
                      <div className='card-bottom'>
                        <div className='card-submenu'>{submenuItem.label}</div>
                      </div>
                    </div>
                  </NavLink>
                )}
              </React.Fragment>
            ))
          ) : (
            <NavLink to={item.link} key={index}>
              <div className="card">
                <div className='card-top'>
                  <div>{item.icon}</div>
                  <div className="card-label">{item.label}</div>
                </div>
                <div className='card-bottom'>
                  <div className='card-submenu'>{item.label}</div>
                </div>
              </div>
            </NavLink>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default CardView;
